import { MyIcon } from "@macashipo/mlib"

export default MyIcon
